import { GetExecutionOutputArgs, GetExecutionOutputArgsOptions } from "./GetExecutionOutputArgs";
import { PostProcessingOutputType } from "../../../models/PostProcessingOutputType";

export interface GetExecutionPostProcessingOutputArgsOptions extends GetExecutionOutputArgsOptions {
    outputType: PostProcessingOutputType;
}

export class GetExecutionPostProcessingOutputArgs extends GetExecutionOutputArgs {

    public outputType: PostProcessingOutputType;

    constructor(options: GetExecutionPostProcessingOutputArgsOptions) {
        if (options.outputType == null) throw new Error("outputType is required!");
        super(options);
        this.outputType = options.outputType;
    }

}
